/**
 * @fileoverview Auth Configuration (BFF Pattern)
 * @description Auth is now handled server-side by the backend BFF.
 *              This file retains endpoint references for documentation
 *              and any frontend code that still references authConfig.
 * @module config/authConfig
 */

/**
 * PingFederate Endpoints (for reference only — used by backend)
 */
export const pingFederateEndpoints = {
  discovery: 'https://fedauth.qa.alaskasworld.com/.well-known/openid-configuration',
  authorization: 'https://fedauth.qa.alaskasworld.com/as/authorization.oauth2',
  token: 'https://fedauth.qa.alaskasworld.com/as/token.oauth2',
  userinfo: 'https://fedauth.qa.alaskasworld.com/idp/userinfo.openid',
  jwks: 'https://fedauth.qa.alaskasworld.com/pf/JWKS',
  issuer: 'https://fedauth.qa.alaskasworld.com',
};

/**
 * Kept for backward compatibility — some components may still import authConfig.
 * Client ID is no longer used in the frontend; the backend handles it.
 */
export const authConfig = {
  authority: pingFederateEndpoints.issuer,
  client_id: '', // Managed by backend
};

export default authConfig;
